export const representativeKey = 'representative'
export const selectedInstitutionKey = 'selectedInstitution'
export const accessTokenKey = 'accessToken'
export const listPromotionsWithoutGoalKey = 'listPromotionsWithoutGoalKey'
export const travelLinkKey = 'travelLink'
export const graduationlLinkKey = 'graduationlLink'